import { cn } from '@Utils/cn';
import { GuestSpendStats } from '../GuestSpendStats';
import { GuestTabRail } from '../GuestTabRail';
import type { GuestSpendSummary, GuestTabOption } from '../types';

export interface GuestDetailsHeaderProps<T extends string = string> {
  tabs: GuestTabOption<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  spendSummary?: GuestSpendSummary;
  className?: string;
}

/**
 * Tab rail with the spend summary alongside it. When both don't fit on one
 * line, the summary wraps above the rail so the tabs stay on the bottom border.
 */
export function GuestDetailsHeader<T extends string = string>({
  tabs,
  activeTab,
  onTabChange,
  spendSummary,
  className,
}: GuestDetailsHeaderProps<T>) {
  return (
    <div
      className={cn(
        'flex flex-wrap-reverse items-end justify-between gap-x-4 border-b border-aoh-border dark:border-zinc-500',
        className,
      )}
    >
      <GuestTabRail
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        className="scrollbar-dark min-w-0 overflow-x-auto"
      />
      {spendSummary && (
        <GuestSpendStats spendSummary={spendSummary} className="ml-auto" />
      )}
    </div>
  );
}
